enum PRINT_STATUS {
    DONE = "DONE",
    ERROR = "ERROR"
}

export default { PRINT_STATUS }